export default "__VITE_ASSET__93d7718a__"